export const str = (obj: any) => `${obj}`;
